export default __webpack_public_path__ + "static/media/adduser.df65db02.svg";